var Tt = Object.defineProperty, At = Object.defineProperties;
var xt = Object.getOwnPropertyDescriptors;
var _e = Object.getOwnPropertySymbols;
var Ct = Object.prototype.hasOwnProperty, Nt = Object.prototype.propertyIsEnumerable;
var z = (e, t) => (t = Symbol[e]) ? t : Symbol.for("Symbol." + e), Pt = (e) => {
  throw TypeError(e);
};
var De = (e, t, n) => t in e ? Tt(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, D = (e, t) => {
  for (var n in t || (t = {}))
    Ct.call(t, n) && De(e, n, t[n]);
  if (_e)
    for (var n of _e(t))
      Nt.call(t, n) && De(e, n, t[n]);
  return e;
}, Ie = (e, t) => At(e, xt(t));
var B = (e, t, n) => new Promise((r, s) => {
  var i = (d) => {
    try {
      c(n.next(d));
    } catch (l) {
      s(l);
    }
  }, o = (d) => {
    try {
      c(n.throw(d));
    } catch (l) {
      s(l);
    }
  }, c = (d) => d.done ? r(d.value) : Promise.resolve(d.value).then(i, o);
  c((n = n.apply(e, t)).next());
}), j = function(e, t) {
  this[0] = e, this[1] = t;
}, pe = (e, t, n) => {
  var r = (o, c, d, l) => {
    try {
      var u = n[o](c), p = (c = u.value) instanceof j, b = u.done;
      Promise.resolve(p ? c[0] : c).then((w) => p ? r(o === "return" ? o : "next", c[1] ? { done: w.done, value: w.value } : w, d, l) : d({ value: w, done: b })).catch((w) => r("throw", w, d, l));
    } catch (w) {
      l(w);
    }
  }, s = (o) => i[o] = (c) => new Promise((d, l) => r(o, c, d, l)), i = {};
  return n = n.apply(e, t), i[z("asyncIterator")] = () => i, s("next"), s("throw"), s("return"), i;
}, me = (e) => {
  var t = e[z("asyncIterator")], n = !1, r, s = {};
  return t == null ? (t = e[z("iterator")](), r = (i) => s[i] = (o) => t[i](o)) : (t = t.call(e), r = (i) => s[i] = (o) => {
    if (n) {
      if (n = !1, i === "throw") throw o;
      return o;
    }
    return n = !0, {
      done: !1,
      value: new j(new Promise((c) => {
        var d = t[i](o);
        d instanceof Object || Pt("Object expected"), c(d);
      }), 1)
    };
  }), s[z("iterator")] = () => s, r("next"), "throw" in t ? r("throw") : s.throw = (i) => {
    throw i;
  }, "return" in t && r("return"), s;
}, ke = (e, t, n) => (t = e[z("asyncIterator")]) ? t.call(e) : (e = e[z("iterator")](), t = {}, n = (r, s) => (s = e[r]) && (t[r] = (i) => new Promise((o, c, d) => (i = s.call(e, i), d = i.done, Promise.resolve(i.value).then((l) => o({ value: l, done: d }), c)))), n("next"), n("return"), t);
function Ye(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: Ut } = Object.prototype, { getPrototypeOf: Oe } = Object, { iterator: ae, toStringTag: et } = Symbol, ce = /* @__PURE__ */ ((e) => (t) => {
  const n = Ut.call(t);
  return e[n] || (e[n] = n.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), P = (e) => (e = e.toLowerCase(), (t) => ce(t) === e), le = (e) => (t) => typeof t === e, { isArray: v } = Array, J = le("undefined");
function X(e) {
  return e !== null && !J(e) && e.constructor !== null && !J(e.constructor) && T(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const tt = P("ArrayBuffer");
function Ft(e) {
  let t;
  return typeof ArrayBuffer != "undefined" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && tt(e.buffer), t;
}
const Lt = le("string"), T = le("function"), nt = le("number"), G = (e) => e !== null && typeof e == "object", _t = (e) => e === !0 || e === !1, re = (e) => {
  if (ce(e) !== "object")
    return !1;
  const t = Oe(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(et in e) && !(ae in e);
}, Dt = (e) => {
  if (!G(e) || X(e))
    return !1;
  try {
    return Object.keys(e).length === 0 && Object.getPrototypeOf(e) === Object.prototype;
  } catch (t) {
    return !1;
  }
}, It = P("Date"), kt = P("File"), Bt = P("Blob"), jt = P("FileList"), qt = (e) => G(e) && T(e.pipe), Mt = (e) => {
  let t;
  return e && (typeof FormData == "function" && e instanceof FormData || T(e.append) && ((t = ce(e)) === "formdata" || // detect form-data instance
  t === "object" && T(e.toString) && e.toString() === "[object FormData]"));
}, Ht = P("URLSearchParams"), [$t, zt, Jt, vt] = ["ReadableStream", "Request", "Response", "Headers"].map(P), Vt = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function Q(e, t, { allOwnKeys: n = !1 } = {}) {
  if (e === null || typeof e == "undefined")
    return;
  let r, s;
  if (typeof e != "object" && (e = [e]), v(e))
    for (r = 0, s = e.length; r < s; r++)
      t.call(null, e[r], r, e);
  else {
    if (X(e))
      return;
    const i = n ? Object.getOwnPropertyNames(e) : Object.keys(e), o = i.length;
    let c;
    for (r = 0; r < o; r++)
      c = i[r], t.call(null, e[c], c, e);
  }
}
function rt(e, t) {
  if (X(e))
    return null;
  t = t.toLowerCase();
  const n = Object.keys(e);
  let r = n.length, s;
  for (; r-- > 0; )
    if (s = n[r], t === s.toLowerCase())
      return s;
  return null;
}
const q = typeof globalThis != "undefined" ? globalThis : typeof self != "undefined" ? self : typeof window != "undefined" ? window : global, st = (e) => !J(e) && e !== q;
function ge() {
  const { caseless: e, skipUndefined: t } = st(this) && this || {}, n = {}, r = (s, i) => {
    const o = e && rt(n, i) || i;
    re(n[o]) && re(s) ? n[o] = ge(n[o], s) : re(s) ? n[o] = ge({}, s) : v(s) ? n[o] = s.slice() : (!t || !J(s)) && (n[o] = s);
  };
  for (let s = 0, i = arguments.length; s < i; s++)
    arguments[s] && Q(arguments[s], r);
  return n;
}
const Wt = (e, t, n, { allOwnKeys: r } = {}) => (Q(t, (s, i) => {
  n && T(s) ? e[i] = Ye(s, n) : e[i] = s;
}, { allOwnKeys: r }), e), Kt = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), Xt = (e, t, n, r) => {
  e.prototype = Object.create(t.prototype, r), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: t.prototype
  }), n && Object.assign(e.prototype, n);
}, Gt = (e, t, n, r) => {
  let s, i, o;
  const c = {};
  if (t = t || {}, e == null) return t;
  do {
    for (s = Object.getOwnPropertyNames(e), i = s.length; i-- > 0; )
      o = s[i], (!r || r(o, e, t)) && !c[o] && (t[o] = e[o], c[o] = !0);
    e = n !== !1 && Oe(e);
  } while (e && (!n || n(e, t)) && e !== Object.prototype);
  return t;
}, Qt = (e, t, n) => {
  e = String(e), (n === void 0 || n > e.length) && (n = e.length), n -= t.length;
  const r = e.indexOf(t, n);
  return r !== -1 && r === n;
}, Zt = (e) => {
  if (!e) return null;
  if (v(e)) return e;
  let t = e.length;
  if (!nt(t)) return null;
  const n = new Array(t);
  for (; t-- > 0; )
    n[t] = e[t];
  return n;
}, Yt = /* @__PURE__ */ ((e) => (t) => e && t instanceof e)(typeof Uint8Array != "undefined" && Oe(Uint8Array)), en = (e, t) => {
  const r = (e && e[ae]).call(e);
  let s;
  for (; (s = r.next()) && !s.done; ) {
    const i = s.value;
    t.call(e, i[0], i[1]);
  }
}, tn = (e, t) => {
  let n;
  const r = [];
  for (; (n = e.exec(t)) !== null; )
    r.push(n);
  return r;
}, nn = P("HTMLFormElement"), rn = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(n, r, s) {
    return r.toUpperCase() + s;
  }
), Be = (({ hasOwnProperty: e }) => (t, n) => e.call(t, n))(Object.prototype), sn = P("RegExp"), ot = (e, t) => {
  const n = Object.getOwnPropertyDescriptors(e), r = {};
  Q(n, (s, i) => {
    let o;
    (o = t(s, i, e)) !== !1 && (r[i] = o || s);
  }), Object.defineProperties(e, r);
}, on = (e) => {
  ot(e, (t, n) => {
    if (T(e) && ["arguments", "caller", "callee"].indexOf(n) !== -1)
      return !1;
    const r = e[n];
    if (T(r)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + n + "'");
      });
    }
  });
}, an = (e, t) => {
  const n = {}, r = (s) => {
    s.forEach((i) => {
      n[i] = !0;
    });
  };
  return v(e) ? r(e) : r(String(e).split(t)), n;
}, cn = () => {
}, ln = (e, t) => e != null && Number.isFinite(e = +e) ? e : t;
function un(e) {
  return !!(e && T(e.append) && e[et] === "FormData" && e[ae]);
}
const fn = (e) => {
  const t = new Array(10), n = (r, s) => {
    if (G(r)) {
      if (t.indexOf(r) >= 0)
        return;
      if (X(r))
        return r;
      if (!("toJSON" in r)) {
        t[s] = r;
        const i = v(r) ? [] : {};
        return Q(r, (o, c) => {
          const d = n(o, s + 1);
          !J(d) && (i[c] = d);
        }), t[s] = void 0, i;
      }
    }
    return r;
  };
  return n(e, 0);
}, dn = P("AsyncFunction"), hn = (e) => e && (G(e) || T(e)) && T(e.then) && T(e.catch), it = ((e, t) => e ? setImmediate : t ? ((n, r) => (q.addEventListener("message", ({ source: s, data: i }) => {
  s === q && i === n && r.length && r.shift()();
}, !1), (s) => {
  r.push(s), q.postMessage(n, "*");
}))(`axios@${Math.random()}`, []) : (n) => setTimeout(n))(
  typeof setImmediate == "function",
  T(q.postMessage)
), pn = typeof queueMicrotask != "undefined" ? queueMicrotask.bind(q) : typeof process != "undefined" && process.nextTick || it, mn = (e) => e != null && T(e[ae]), a = {
  isArray: v,
  isArrayBuffer: tt,
  isBuffer: X,
  isFormData: Mt,
  isArrayBufferView: Ft,
  isString: Lt,
  isNumber: nt,
  isBoolean: _t,
  isObject: G,
  isPlainObject: re,
  isEmptyObject: Dt,
  isReadableStream: $t,
  isRequest: zt,
  isResponse: Jt,
  isHeaders: vt,
  isUndefined: J,
  isDate: It,
  isFile: kt,
  isBlob: Bt,
  isRegExp: sn,
  isFunction: T,
  isStream: qt,
  isURLSearchParams: Ht,
  isTypedArray: Yt,
  isFileList: jt,
  forEach: Q,
  merge: ge,
  extend: Wt,
  trim: Vt,
  stripBOM: Kt,
  inherits: Xt,
  toFlatObject: Gt,
  kindOf: ce,
  kindOfTest: P,
  endsWith: Qt,
  toArray: Zt,
  forEachEntry: en,
  matchAll: tn,
  isHTMLForm: nn,
  hasOwnProperty: Be,
  hasOwnProp: Be,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: ot,
  freezeMethods: on,
  toObjectSet: an,
  toCamelCase: rn,
  noop: cn,
  toFiniteNumber: ln,
  findKey: rt,
  global: q,
  isContextDefined: st,
  isSpecCompliantForm: un,
  toJSONObject: fn,
  isAsyncFn: dn,
  isThenable: hn,
  setImmediate: it,
  asap: pn,
  isIterable: mn
};
function y(e, t, n, r, s) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), n && (this.config = n), r && (this.request = r), s && (this.response = s, this.status = s.status ? s.status : null);
}
a.inherits(y, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: a.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const at = y.prototype, ct = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  ct[e] = { value: e };
});
Object.defineProperties(y, ct);
Object.defineProperty(at, "isAxiosError", { value: !0 });
y.from = (e, t, n, r, s, i) => {
  const o = Object.create(at);
  a.toFlatObject(e, o, function(u) {
    return u !== Error.prototype;
  }, (l) => l !== "isAxiosError");
  const c = e && e.message ? e.message : "Error", d = t == null && e ? e.code : t;
  return y.call(o, c, d, n, r, s), e && o.cause == null && Object.defineProperty(o, "cause", { value: e, configurable: !0 }), o.name = e && e.name || "Error", i && Object.assign(o, i), o;
};
const yn = null;
function Ee(e) {
  return a.isPlainObject(e) || a.isArray(e);
}
function lt(e) {
  return a.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function je(e, t, n) {
  return e ? e.concat(t).map(function(s, i) {
    return s = lt(s), !n && i ? "[" + s + "]" : s;
  }).join(n ? "." : "") : t;
}
function bn(e) {
  return a.isArray(e) && !e.some(Ee);
}
const wn = a.toFlatObject(a, {}, null, function(t) {
  return /^is[A-Z]/.test(t);
});
function ue(e, t, n) {
  if (!a.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), n = a.toFlatObject(n, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(m, h) {
    return !a.isUndefined(h[m]);
  });
  const r = n.metaTokens, s = n.visitor || u, i = n.dots, o = n.indexes, d = (n.Blob || typeof Blob != "undefined" && Blob) && a.isSpecCompliantForm(t);
  if (!a.isFunction(s))
    throw new TypeError("visitor must be a function");
  function l(f) {
    if (f === null) return "";
    if (a.isDate(f))
      return f.toISOString();
    if (a.isBoolean(f))
      return f.toString();
    if (!d && a.isBlob(f))
      throw new y("Blob is not supported. Use a Buffer instead.");
    return a.isArrayBuffer(f) || a.isTypedArray(f) ? d && typeof Blob == "function" ? new Blob([f]) : Buffer.from(f) : f;
  }
  function u(f, m, h) {
    let E = f;
    if (f && !h && typeof f == "object") {
      if (a.endsWith(m, "{}"))
        m = r ? m : m.slice(0, -2), f = JSON.stringify(f);
      else if (a.isArray(f) && bn(f) || (a.isFileList(f) || a.endsWith(m, "[]")) && (E = a.toArray(f)))
        return m = lt(m), E.forEach(function(S, O) {
          !(a.isUndefined(S) || S === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            o === !0 ? je([m], O, i) : o === null ? m : m + "[]",
            l(S)
          );
        }), !1;
    }
    return Ee(f) ? !0 : (t.append(je(h, m, i), l(f)), !1);
  }
  const p = [], b = Object.assign(wn, {
    defaultVisitor: u,
    convertValue: l,
    isVisitable: Ee
  });
  function w(f, m) {
    if (!a.isUndefined(f)) {
      if (p.indexOf(f) !== -1)
        throw Error("Circular reference detected in " + m.join("."));
      p.push(f), a.forEach(f, function(E, x) {
        (!(a.isUndefined(E) || E === null) && s.call(
          t,
          E,
          a.isString(x) ? x.trim() : x,
          m,
          b
        )) === !0 && w(E, m ? m.concat(x) : [x]);
      }), p.pop();
    }
  }
  if (!a.isObject(e))
    throw new TypeError("data must be an object");
  return w(e), t;
}
function qe(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(r) {
    return t[r];
  });
}
function Te(e, t) {
  this._pairs = [], e && ue(e, this, t);
}
const ut = Te.prototype;
ut.append = function(t, n) {
  this._pairs.push([t, n]);
};
ut.toString = function(t) {
  const n = t ? function(r) {
    return t.call(this, r, qe);
  } : qe;
  return this._pairs.map(function(s) {
    return n(s[0]) + "=" + n(s[1]);
  }, "").join("&");
};
function gn(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function ft(e, t, n) {
  if (!t)
    return e;
  const r = n && n.encode || gn;
  a.isFunction(n) && (n = {
    serialize: n
  });
  const s = n && n.serialize;
  let i;
  if (s ? i = s(t, n) : i = a.isURLSearchParams(t) ? t.toString() : new Te(t, n).toString(r), i) {
    const o = e.indexOf("#");
    o !== -1 && (e = e.slice(0, o)), e += (e.indexOf("?") === -1 ? "?" : "&") + i;
  }
  return e;
}
class Me {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, n, r) {
    return this.handlers.push({
      fulfilled: t,
      rejected: n,
      synchronous: r ? r.synchronous : !1,
      runWhen: r ? r.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    a.forEach(this.handlers, function(r) {
      r !== null && t(r);
    });
  }
}
const dt = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, En = typeof URLSearchParams != "undefined" ? URLSearchParams : Te, Sn = typeof FormData != "undefined" ? FormData : null, Rn = typeof Blob != "undefined" ? Blob : null, On = {
  isBrowser: !0,
  classes: {
    URLSearchParams: En,
    FormData: Sn,
    Blob: Rn
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, Ae = typeof window != "undefined" && typeof document != "undefined", Se = typeof navigator == "object" && navigator || void 0, Tn = Ae && (!Se || ["ReactNative", "NativeScript", "NS"].indexOf(Se.product) < 0), An = typeof WorkerGlobalScope != "undefined" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", xn = Ae && window.location.href || "http://localhost", Cn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: Ae,
  hasStandardBrowserEnv: Tn,
  hasStandardBrowserWebWorkerEnv: An,
  navigator: Se,
  origin: xn
}, Symbol.toStringTag, { value: "Module" })), R = D(D({}, Cn), On);
function Nn(e, t) {
  return ue(e, new R.classes.URLSearchParams(), D({
    visitor: function(n, r, s, i) {
      return R.isNode && a.isBuffer(n) ? (this.append(r, n.toString("base64")), !1) : i.defaultVisitor.apply(this, arguments);
    }
  }, t));
}
function Pn(e) {
  return a.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function Un(e) {
  const t = {}, n = Object.keys(e);
  let r;
  const s = n.length;
  let i;
  for (r = 0; r < s; r++)
    i = n[r], t[i] = e[i];
  return t;
}
function ht(e) {
  function t(n, r, s, i) {
    let o = n[i++];
    if (o === "__proto__") return !0;
    const c = Number.isFinite(+o), d = i >= n.length;
    return o = !o && a.isArray(s) ? s.length : o, d ? (a.hasOwnProp(s, o) ? s[o] = [s[o], r] : s[o] = r, !c) : ((!s[o] || !a.isObject(s[o])) && (s[o] = []), t(n, r, s[o], i) && a.isArray(s[o]) && (s[o] = Un(s[o])), !c);
  }
  if (a.isFormData(e) && a.isFunction(e.entries)) {
    const n = {};
    return a.forEachEntry(e, (r, s) => {
      t(Pn(r), s, n, 0);
    }), n;
  }
  return null;
}
function Fn(e, t, n) {
  if (a.isString(e))
    try {
      return (t || JSON.parse)(e), a.trim(e);
    } catch (r) {
      if (r.name !== "SyntaxError")
        throw r;
    }
  return (n || JSON.stringify)(e);
}
const Z = {
  transitional: dt,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(t, n) {
    const r = n.getContentType() || "", s = r.indexOf("application/json") > -1, i = a.isObject(t);
    if (i && a.isHTMLForm(t) && (t = new FormData(t)), a.isFormData(t))
      return s ? JSON.stringify(ht(t)) : t;
    if (a.isArrayBuffer(t) || a.isBuffer(t) || a.isStream(t) || a.isFile(t) || a.isBlob(t) || a.isReadableStream(t))
      return t;
    if (a.isArrayBufferView(t))
      return t.buffer;
    if (a.isURLSearchParams(t))
      return n.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
    let c;
    if (i) {
      if (r.indexOf("application/x-www-form-urlencoded") > -1)
        return Nn(t, this.formSerializer).toString();
      if ((c = a.isFileList(t)) || r.indexOf("multipart/form-data") > -1) {
        const d = this.env && this.env.FormData;
        return ue(
          c ? { "files[]": t } : t,
          d && new d(),
          this.formSerializer
        );
      }
    }
    return i || s ? (n.setContentType("application/json", !1), Fn(t)) : t;
  }],
  transformResponse: [function(t) {
    const n = this.transitional || Z.transitional, r = n && n.forcedJSONParsing, s = this.responseType === "json";
    if (a.isResponse(t) || a.isReadableStream(t))
      return t;
    if (t && a.isString(t) && (r && !this.responseType || s)) {
      const o = !(n && n.silentJSONParsing) && s;
      try {
        return JSON.parse(t, this.parseReviver);
      } catch (c) {
        if (o)
          throw c.name === "SyntaxError" ? y.from(c, y.ERR_BAD_RESPONSE, this, null, this.response) : c;
      }
    }
    return t;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: R.classes.FormData,
    Blob: R.classes.Blob
  },
  validateStatus: function(t) {
    return t >= 200 && t < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
a.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  Z.headers[e] = {};
});
const Ln = a.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), _n = (e) => {
  const t = {};
  let n, r, s;
  return e && e.split(`
`).forEach(function(o) {
    s = o.indexOf(":"), n = o.substring(0, s).trim().toLowerCase(), r = o.substring(s + 1).trim(), !(!n || t[n] && Ln[n]) && (n === "set-cookie" ? t[n] ? t[n].push(r) : t[n] = [r] : t[n] = t[n] ? t[n] + ", " + r : r);
  }), t;
}, He = Symbol("internals");
function K(e) {
  return e && String(e).trim().toLowerCase();
}
function se(e) {
  return e === !1 || e == null ? e : a.isArray(e) ? e.map(se) : String(e);
}
function Dn(e) {
  const t = /* @__PURE__ */ Object.create(null), n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let r;
  for (; r = n.exec(e); )
    t[r[1]] = r[2];
  return t;
}
const In = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function ye(e, t, n, r, s) {
  if (a.isFunction(r))
    return r.call(this, t, n);
  if (s && (t = n), !!a.isString(t)) {
    if (a.isString(r))
      return t.indexOf(r) !== -1;
    if (a.isRegExp(r))
      return r.test(t);
  }
}
function kn(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, n, r) => n.toUpperCase() + r);
}
function Bn(e, t) {
  const n = a.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((r) => {
    Object.defineProperty(e, r + n, {
      value: function(s, i, o) {
        return this[r].call(this, t, s, i, o);
      },
      configurable: !0
    });
  });
}
let A = class {
  constructor(t) {
    t && this.set(t);
  }
  set(t, n, r) {
    const s = this;
    function i(c, d, l) {
      const u = K(d);
      if (!u)
        throw new Error("header name must be a non-empty string");
      const p = a.findKey(s, u);
      (!p || s[p] === void 0 || l === !0 || l === void 0 && s[p] !== !1) && (s[p || d] = se(c));
    }
    const o = (c, d) => a.forEach(c, (l, u) => i(l, u, d));
    if (a.isPlainObject(t) || t instanceof this.constructor)
      o(t, n);
    else if (a.isString(t) && (t = t.trim()) && !In(t))
      o(_n(t), n);
    else if (a.isObject(t) && a.isIterable(t)) {
      let c = {}, d, l;
      for (const u of t) {
        if (!a.isArray(u))
          throw TypeError("Object iterator must return a key-value pair");
        c[l = u[0]] = (d = c[l]) ? a.isArray(d) ? [...d, u[1]] : [d, u[1]] : u[1];
      }
      o(c, n);
    } else
      t != null && i(n, t, r);
    return this;
  }
  get(t, n) {
    if (t = K(t), t) {
      const r = a.findKey(this, t);
      if (r) {
        const s = this[r];
        if (!n)
          return s;
        if (n === !0)
          return Dn(s);
        if (a.isFunction(n))
          return n.call(this, s, r);
        if (a.isRegExp(n))
          return n.exec(s);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, n) {
    if (t = K(t), t) {
      const r = a.findKey(this, t);
      return !!(r && this[r] !== void 0 && (!n || ye(this, this[r], r, n)));
    }
    return !1;
  }
  delete(t, n) {
    const r = this;
    let s = !1;
    function i(o) {
      if (o = K(o), o) {
        const c = a.findKey(r, o);
        c && (!n || ye(r, r[c], c, n)) && (delete r[c], s = !0);
      }
    }
    return a.isArray(t) ? t.forEach(i) : i(t), s;
  }
  clear(t) {
    const n = Object.keys(this);
    let r = n.length, s = !1;
    for (; r--; ) {
      const i = n[r];
      (!t || ye(this, this[i], i, t, !0)) && (delete this[i], s = !0);
    }
    return s;
  }
  normalize(t) {
    const n = this, r = {};
    return a.forEach(this, (s, i) => {
      const o = a.findKey(r, i);
      if (o) {
        n[o] = se(s), delete n[i];
        return;
      }
      const c = t ? kn(i) : String(i).trim();
      c !== i && delete n[i], n[c] = se(s), r[c] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const n = /* @__PURE__ */ Object.create(null);
    return a.forEach(this, (r, s) => {
      r != null && r !== !1 && (n[s] = t && a.isArray(r) ? r.join(", ") : r);
    }), n;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, n]) => t + ": " + n).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...n) {
    const r = new this(t);
    return n.forEach((s) => r.set(s)), r;
  }
  static accessor(t) {
    const r = (this[He] = this[He] = {
      accessors: {}
    }).accessors, s = this.prototype;
    function i(o) {
      const c = K(o);
      r[c] || (Bn(s, o), r[c] = !0);
    }
    return a.isArray(t) ? t.forEach(i) : i(t), this;
  }
};
A.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
a.reduceDescriptors(A.prototype, ({ value: e }, t) => {
  let n = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => e,
    set(r) {
      this[n] = r;
    }
  };
});
a.freezeMethods(A);
function be(e, t) {
  const n = this || Z, r = t || n, s = A.from(r.headers);
  let i = r.data;
  return a.forEach(e, function(c) {
    i = c.call(n, i, s.normalize(), t ? t.status : void 0);
  }), s.normalize(), i;
}
function pt(e) {
  return !!(e && e.__CANCEL__);
}
function V(e, t, n) {
  y.call(this, e == null ? "canceled" : e, y.ERR_CANCELED, t, n), this.name = "CanceledError";
}
a.inherits(V, y, {
  __CANCEL__: !0
});
function mt(e, t, n) {
  const r = n.config.validateStatus;
  !n.status || !r || r(n.status) ? e(n) : t(new y(
    "Request failed with status code " + n.status,
    [y.ERR_BAD_REQUEST, y.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4],
    n.config,
    n.request,
    n
  ));
}
function jn(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function qn(e, t) {
  e = e || 10;
  const n = new Array(e), r = new Array(e);
  let s = 0, i = 0, o;
  return t = t !== void 0 ? t : 1e3, function(d) {
    const l = Date.now(), u = r[i];
    o || (o = l), n[s] = d, r[s] = l;
    let p = i, b = 0;
    for (; p !== s; )
      b += n[p++], p = p % e;
    if (s = (s + 1) % e, s === i && (i = (i + 1) % e), l - o < t)
      return;
    const w = u && l - u;
    return w ? Math.round(b * 1e3 / w) : void 0;
  };
}
function Mn(e, t) {
  let n = 0, r = 1e3 / t, s, i;
  const o = (l, u = Date.now()) => {
    n = u, s = null, i && (clearTimeout(i), i = null), e(...l);
  };
  return [(...l) => {
    const u = Date.now(), p = u - n;
    p >= r ? o(l, u) : (s = l, i || (i = setTimeout(() => {
      i = null, o(s);
    }, r - p)));
  }, () => s && o(s)];
}
const ie = (e, t, n = 3) => {
  let r = 0;
  const s = qn(50, 250);
  return Mn((i) => {
    const o = i.loaded, c = i.lengthComputable ? i.total : void 0, d = o - r, l = s(d), u = o <= c;
    r = o;
    const p = {
      loaded: o,
      total: c,
      progress: c ? o / c : void 0,
      bytes: d,
      rate: l || void 0,
      estimated: l && c && u ? (c - o) / l : void 0,
      event: i,
      lengthComputable: c != null,
      [t ? "download" : "upload"]: !0
    };
    e(p);
  }, n);
}, $e = (e, t) => {
  const n = e != null;
  return [(r) => t[0]({
    lengthComputable: n,
    total: e,
    loaded: r
  }), t[1]];
}, ze = (e) => (...t) => a.asap(() => e(...t)), Hn = R.hasStandardBrowserEnv ? /* @__PURE__ */ ((e, t) => (n) => (n = new URL(n, R.origin), e.protocol === n.protocol && e.host === n.host && (t || e.port === n.port)))(
  new URL(R.origin),
  R.navigator && /(msie|trident)/i.test(R.navigator.userAgent)
) : () => !0, $n = R.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, t, n, r, s, i, o) {
      if (typeof document == "undefined") return;
      const c = [`${e}=${encodeURIComponent(t)}`];
      a.isNumber(n) && c.push(`expires=${new Date(n).toUTCString()}`), a.isString(r) && c.push(`path=${r}`), a.isString(s) && c.push(`domain=${s}`), i === !0 && c.push("secure"), a.isString(o) && c.push(`SameSite=${o}`), document.cookie = c.join("; ");
    },
    read(e) {
      if (typeof document == "undefined") return null;
      const t = document.cookie.match(new RegExp("(?:^|; )" + e + "=([^;]*)"));
      return t ? decodeURIComponent(t[1]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5, "/");
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function zn(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function Jn(e, t) {
  return t ? e.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function yt(e, t, n) {
  let r = !zn(t);
  return e && (r || n == !1) ? Jn(e, t) : t;
}
const Je = (e) => e instanceof A ? D({}, e) : e;
function H(e, t) {
  t = t || {};
  const n = {};
  function r(l, u, p, b) {
    return a.isPlainObject(l) && a.isPlainObject(u) ? a.merge.call({ caseless: b }, l, u) : a.isPlainObject(u) ? a.merge({}, u) : a.isArray(u) ? u.slice() : u;
  }
  function s(l, u, p, b) {
    if (a.isUndefined(u)) {
      if (!a.isUndefined(l))
        return r(void 0, l, p, b);
    } else return r(l, u, p, b);
  }
  function i(l, u) {
    if (!a.isUndefined(u))
      return r(void 0, u);
  }
  function o(l, u) {
    if (a.isUndefined(u)) {
      if (!a.isUndefined(l))
        return r(void 0, l);
    } else return r(void 0, u);
  }
  function c(l, u, p) {
    if (p in t)
      return r(l, u);
    if (p in e)
      return r(void 0, l);
  }
  const d = {
    url: i,
    method: i,
    data: i,
    baseURL: o,
    transformRequest: o,
    transformResponse: o,
    paramsSerializer: o,
    timeout: o,
    timeoutMessage: o,
    withCredentials: o,
    withXSRFToken: o,
    adapter: o,
    responseType: o,
    xsrfCookieName: o,
    xsrfHeaderName: o,
    onUploadProgress: o,
    onDownloadProgress: o,
    decompress: o,
    maxContentLength: o,
    maxBodyLength: o,
    beforeRedirect: o,
    transport: o,
    httpAgent: o,
    httpsAgent: o,
    cancelToken: o,
    socketPath: o,
    responseEncoding: o,
    validateStatus: c,
    headers: (l, u, p) => s(Je(l), Je(u), p, !0)
  };
  return a.forEach(Object.keys(D(D({}, e), t)), function(u) {
    const p = d[u] || s, b = p(e[u], t[u], u);
    a.isUndefined(b) && p !== c || (n[u] = b);
  }), n;
}
const bt = (e) => {
  const t = H({}, e);
  let { data: n, withXSRFToken: r, xsrfHeaderName: s, xsrfCookieName: i, headers: o, auth: c } = t;
  if (t.headers = o = A.from(o), t.url = ft(yt(t.baseURL, t.url, t.allowAbsoluteUrls), e.params, e.paramsSerializer), c && o.set(
    "Authorization",
    "Basic " + btoa((c.username || "") + ":" + (c.password ? unescape(encodeURIComponent(c.password)) : ""))
  ), a.isFormData(n)) {
    if (R.hasStandardBrowserEnv || R.hasStandardBrowserWebWorkerEnv)
      o.setContentType(void 0);
    else if (a.isFunction(n.getHeaders)) {
      const d = n.getHeaders(), l = ["content-type", "content-length"];
      Object.entries(d).forEach(([u, p]) => {
        l.includes(u.toLowerCase()) && o.set(u, p);
      });
    }
  }
  if (R.hasStandardBrowserEnv && (r && a.isFunction(r) && (r = r(t)), r || r !== !1 && Hn(t.url))) {
    const d = s && i && $n.read(i);
    d && o.set(s, d);
  }
  return t;
}, vn = typeof XMLHttpRequest != "undefined", Vn = vn && function(e) {
  return new Promise(function(n, r) {
    const s = bt(e);
    let i = s.data;
    const o = A.from(s.headers).normalize();
    let { responseType: c, onUploadProgress: d, onDownloadProgress: l } = s, u, p, b, w, f;
    function m() {
      w && w(), f && f(), s.cancelToken && s.cancelToken.unsubscribe(u), s.signal && s.signal.removeEventListener("abort", u);
    }
    let h = new XMLHttpRequest();
    h.open(s.method.toUpperCase(), s.url, !0), h.timeout = s.timeout;
    function E() {
      if (!h)
        return;
      const S = A.from(
        "getAllResponseHeaders" in h && h.getAllResponseHeaders()
      ), N = {
        data: !c || c === "text" || c === "json" ? h.responseText : h.response,
        status: h.status,
        statusText: h.statusText,
        headers: S,
        config: e,
        request: h
      };
      mt(function(C) {
        n(C), m();
      }, function(C) {
        r(C), m();
      }, N), h = null;
    }
    "onloadend" in h ? h.onloadend = E : h.onreadystatechange = function() {
      !h || h.readyState !== 4 || h.status === 0 && !(h.responseURL && h.responseURL.indexOf("file:") === 0) || setTimeout(E);
    }, h.onabort = function() {
      h && (r(new y("Request aborted", y.ECONNABORTED, e, h)), h = null);
    }, h.onerror = function(O) {
      const N = O && O.message ? O.message : "Network Error", I = new y(N, y.ERR_NETWORK, e, h);
      I.event = O || null, r(I), h = null;
    }, h.ontimeout = function() {
      let O = s.timeout ? "timeout of " + s.timeout + "ms exceeded" : "timeout exceeded";
      const N = s.transitional || dt;
      s.timeoutErrorMessage && (O = s.timeoutErrorMessage), r(new y(
        O,
        N.clarifyTimeoutError ? y.ETIMEDOUT : y.ECONNABORTED,
        e,
        h
      )), h = null;
    }, i === void 0 && o.setContentType(null), "setRequestHeader" in h && a.forEach(o.toJSON(), function(O, N) {
      h.setRequestHeader(N, O);
    }), a.isUndefined(s.withCredentials) || (h.withCredentials = !!s.withCredentials), c && c !== "json" && (h.responseType = s.responseType), l && ([b, f] = ie(l, !0), h.addEventListener("progress", b)), d && h.upload && ([p, w] = ie(d), h.upload.addEventListener("progress", p), h.upload.addEventListener("loadend", w)), (s.cancelToken || s.signal) && (u = (S) => {
      h && (r(!S || S.type ? new V(null, e, h) : S), h.abort(), h = null);
    }, s.cancelToken && s.cancelToken.subscribe(u), s.signal && (s.signal.aborted ? u() : s.signal.addEventListener("abort", u)));
    const x = jn(s.url);
    if (x && R.protocols.indexOf(x) === -1) {
      r(new y("Unsupported protocol " + x + ":", y.ERR_BAD_REQUEST, e));
      return;
    }
    h.send(i || null);
  });
}, Wn = (e, t) => {
  const { length: n } = e = e ? e.filter(Boolean) : [];
  if (t || n) {
    let r = new AbortController(), s;
    const i = function(l) {
      if (!s) {
        s = !0, c();
        const u = l instanceof Error ? l : this.reason;
        r.abort(u instanceof y ? u : new V(u instanceof Error ? u.message : u));
      }
    };
    let o = t && setTimeout(() => {
      o = null, i(new y(`timeout ${t} of ms exceeded`, y.ETIMEDOUT));
    }, t);
    const c = () => {
      e && (o && clearTimeout(o), o = null, e.forEach((l) => {
        l.unsubscribe ? l.unsubscribe(i) : l.removeEventListener("abort", i);
      }), e = null);
    };
    e.forEach((l) => l.addEventListener("abort", i));
    const { signal: d } = r;
    return d.unsubscribe = () => a.asap(c), d;
  }
}, Kn = function* (e, t) {
  let n = e.byteLength;
  if (n < t) {
    yield e;
    return;
  }
  let r = 0, s;
  for (; r < n; )
    s = r + t, yield e.slice(r, s), r = s;
}, Xn = function(e, t) {
  return pe(this, null, function* () {
    try {
      for (var n = ke(Gn(e)), r, s, i; r = !(s = yield new j(n.next())).done; r = !1) {
        const o = s.value;
        yield* me(Kn(o, t));
      }
    } catch (s) {
      i = [s];
    } finally {
      try {
        r && (s = n.return) && (yield new j(s.call(n)));
      } finally {
        if (i)
          throw i[0];
      }
    }
  });
}, Gn = function(e) {
  return pe(this, null, function* () {
    if (e[Symbol.asyncIterator]) {
      yield* me(e);
      return;
    }
    const t = e.getReader();
    try {
      for (; ; ) {
        const { done: n, value: r } = yield new j(t.read());
        if (n)
          break;
        yield r;
      }
    } finally {
      yield new j(t.cancel());
    }
  });
}, ve = (e, t, n, r) => {
  const s = Xn(e, t);
  let i = 0, o, c = (l) => {
    o || (o = !0, r && r(l));
  };
  return new ReadableStream({
    pull(l) {
      return B(this, null, function* () {
        try {
          const { done: u, value: p } = yield s.next();
          if (u) {
            c(), l.close();
            return;
          }
          let b = p.byteLength;
          if (n) {
            let w = i += b;
            n(w);
          }
          l.enqueue(new Uint8Array(p));
        } catch (u) {
          throw c(u), u;
        }
      });
    },
    cancel(l) {
      return c(l), s.return();
    }
  }, {
    highWaterMark: 2
  });
}, Ve = 64 * 1024, { isFunction: ne } = a, Qn = (({ Request: e, Response: t }) => ({
  Request: e,
  Response: t
}))(a.global), {
  ReadableStream: We,
  TextEncoder: Ke
} = a.global, Xe = (e, ...t) => {
  try {
    return !!e(...t);
  } catch (n) {
    return !1;
  }
}, Zn = (e) => {
  e = a.merge.call({
    skipUndefined: !0
  }, Qn, e);
  const { fetch: t, Request: n, Response: r } = e, s = t ? ne(t) : typeof fetch == "function", i = ne(n), o = ne(r);
  if (!s)
    return !1;
  const c = s && ne(We), d = s && (typeof Ke == "function" ? /* @__PURE__ */ ((f) => (m) => f.encode(m))(new Ke()) : (f) => B(null, null, function* () {
    return new Uint8Array(yield new n(f).arrayBuffer());
  })), l = i && c && Xe(() => {
    let f = !1;
    const m = new n(R.origin, {
      body: new We(),
      method: "POST",
      get duplex() {
        return f = !0, "half";
      }
    }).headers.has("Content-Type");
    return f && !m;
  }), u = o && c && Xe(() => a.isReadableStream(new r("").body)), p = {
    stream: u && ((f) => f.body)
  };
  s && ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((f) => {
    !p[f] && (p[f] = (m, h) => {
      let E = m && m[f];
      if (E)
        return E.call(m);
      throw new y(`Response type '${f}' is not supported`, y.ERR_NOT_SUPPORT, h);
    });
  });
  const b = (f) => B(null, null, function* () {
    if (f == null)
      return 0;
    if (a.isBlob(f))
      return f.size;
    if (a.isSpecCompliantForm(f))
      return (yield new n(R.origin, {
        method: "POST",
        body: f
      }).arrayBuffer()).byteLength;
    if (a.isArrayBufferView(f) || a.isArrayBuffer(f))
      return f.byteLength;
    if (a.isURLSearchParams(f) && (f = f + ""), a.isString(f))
      return (yield d(f)).byteLength;
  }), w = (f, m) => B(null, null, function* () {
    const h = a.toFiniteNumber(f.getContentLength());
    return h == null ? b(m) : h;
  });
  return (f) => B(null, null, function* () {
    let {
      url: m,
      method: h,
      data: E,
      signal: x,
      cancelToken: S,
      timeout: O,
      onDownloadProgress: N,
      onUploadProgress: I,
      responseType: C,
      headers: de,
      withCredentials: Y = "same-origin",
      fetchOptions: Ce
    } = bt(f), Ne = t || fetch;
    C = C ? (C + "").toLowerCase() : "text";
    let ee = Wn([x, S && S.toAbortSignal()], O), W = null;
    const k = ee && ee.unsubscribe && (() => {
      ee.unsubscribe();
    });
    let Pe;
    try {
      if (I && l && h !== "get" && h !== "head" && (Pe = yield w(de, E)) !== 0) {
        let _ = new n(m, {
          method: "POST",
          body: E,
          duplex: "half"
        }), $;
        if (a.isFormData(E) && ($ = _.headers.get("content-type")) && de.setContentType($), _.body) {
          const [he, te] = $e(
            Pe,
            ie(ze(I))
          );
          E = ve(_.body, Ve, he, te);
        }
      }
      a.isString(Y) || (Y = Y ? "include" : "omit");
      const U = i && "credentials" in n.prototype, Ue = Ie(D({}, Ce), {
        signal: ee,
        method: h.toUpperCase(),
        headers: de.normalize().toJSON(),
        body: E,
        duplex: "half",
        credentials: U ? Y : void 0
      });
      W = i && new n(m, Ue);
      let L = yield i ? Ne(W, Ce) : Ne(m, Ue);
      const Fe = u && (C === "stream" || C === "response");
      if (u && (N || Fe && k)) {
        const _ = {};
        ["status", "statusText", "headers"].forEach((Le) => {
          _[Le] = L[Le];
        });
        const $ = a.toFiniteNumber(L.headers.get("content-length")), [he, te] = N && $e(
          $,
          ie(ze(N), !0)
        ) || [];
        L = new r(
          ve(L.body, Ve, he, () => {
            te && te(), k && k();
          }),
          _
        );
      }
      C = C || "text";
      let Ot = yield p[a.findKey(p, C) || "text"](L, f);
      return !Fe && k && k(), yield new Promise((_, $) => {
        mt(_, $, {
          data: Ot,
          headers: A.from(L.headers),
          status: L.status,
          statusText: L.statusText,
          config: f,
          request: W
        });
      });
    } catch (U) {
      throw k && k(), U && U.name === "TypeError" && /Load failed|fetch/i.test(U.message) ? Object.assign(
        new y("Network Error", y.ERR_NETWORK, f, W),
        {
          cause: U.cause || U
        }
      ) : y.from(U, U && U.code, f, W);
    }
  });
}, Yn = /* @__PURE__ */ new Map(), wt = (e) => {
  let t = e && e.env || {};
  const { fetch: n, Request: r, Response: s } = t, i = [
    r,
    s,
    n
  ];
  let o = i.length, c = o, d, l, u = Yn;
  for (; c--; )
    d = i[c], l = u.get(d), l === void 0 && u.set(d, l = c ? /* @__PURE__ */ new Map() : Zn(t)), u = l;
  return l;
};
wt();
const xe = {
  http: yn,
  xhr: Vn,
  fetch: {
    get: wt
  }
};
a.forEach(xe, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch (n) {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const Ge = (e) => `- ${e}`, er = (e) => a.isFunction(e) || e === null || e === !1;
function tr(e, t) {
  e = a.isArray(e) ? e : [e];
  const { length: n } = e;
  let r, s;
  const i = {};
  for (let o = 0; o < n; o++) {
    r = e[o];
    let c;
    if (s = r, !er(r) && (s = xe[(c = String(r)).toLowerCase()], s === void 0))
      throw new y(`Unknown adapter '${c}'`);
    if (s && (a.isFunction(s) || (s = s.get(t))))
      break;
    i[c || "#" + o] = s;
  }
  if (!s) {
    const o = Object.entries(i).map(
      ([d, l]) => `adapter ${d} ` + (l === !1 ? "is not supported by the environment" : "is not available in the build")
    );
    let c = n ? o.length > 1 ? `since :
` + o.map(Ge).join(`
`) : " " + Ge(o[0]) : "as no adapter specified";
    throw new y(
      "There is no suitable adapter to dispatch the request " + c,
      "ERR_NOT_SUPPORT"
    );
  }
  return s;
}
const gt = {
  /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */
  getAdapter: tr,
  /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */
  adapters: xe
};
function we(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new V(null, e);
}
function Qe(e) {
  return we(e), e.headers = A.from(e.headers), e.data = be.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), gt.getAdapter(e.adapter || Z.adapter, e)(e).then(function(r) {
    return we(e), r.data = be.call(
      e,
      e.transformResponse,
      r
    ), r.headers = A.from(r.headers), r;
  }, function(r) {
    return pt(r) || (we(e), r && r.response && (r.response.data = be.call(
      e,
      e.transformResponse,
      r.response
    ), r.response.headers = A.from(r.response.headers))), Promise.reject(r);
  });
}
const Et = "1.13.2", fe = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  fe[e] = function(r) {
    return typeof r === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const Ze = {};
fe.transitional = function(t, n, r) {
  function s(i, o) {
    return "[Axios v" + Et + "] Transitional option '" + i + "'" + o + (r ? ". " + r : "");
  }
  return (i, o, c) => {
    if (t === !1)
      throw new y(
        s(o, " has been removed" + (n ? " in " + n : "")),
        y.ERR_DEPRECATED
      );
    return n && !Ze[o] && (Ze[o] = !0, console.warn(
      s(
        o,
        " has been deprecated since v" + n + " and will be removed in the near future"
      )
    )), t ? t(i, o, c) : !0;
  };
};
fe.spelling = function(t) {
  return (n, r) => (console.warn(`${r} is likely a misspelling of ${t}`), !0);
};
function nr(e, t, n) {
  if (typeof e != "object")
    throw new y("options must be an object", y.ERR_BAD_OPTION_VALUE);
  const r = Object.keys(e);
  let s = r.length;
  for (; s-- > 0; ) {
    const i = r[s], o = t[i];
    if (o) {
      const c = e[i], d = c === void 0 || o(c, i, e);
      if (d !== !0)
        throw new y("option " + i + " must be " + d, y.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (n !== !0)
      throw new y("Unknown option " + i, y.ERR_BAD_OPTION);
  }
}
const oe = {
  assertOptions: nr,
  validators: fe
}, F = oe.validators;
let M = class {
  constructor(t) {
    this.defaults = t || {}, this.interceptors = {
      request: new Me(),
      response: new Me()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  request(t, n) {
    return B(this, null, function* () {
      try {
        return yield this._request(t, n);
      } catch (r) {
        if (r instanceof Error) {
          let s = {};
          Error.captureStackTrace ? Error.captureStackTrace(s) : s = new Error();
          const i = s.stack ? s.stack.replace(/^.+\n/, "") : "";
          try {
            r.stack ? i && !String(r.stack).endsWith(i.replace(/^.+\n.+\n/, "")) && (r.stack += `
` + i) : r.stack = i;
          } catch (o) {
          }
        }
        throw r;
      }
    });
  }
  _request(t, n) {
    typeof t == "string" ? (n = n || {}, n.url = t) : n = t || {}, n = H(this.defaults, n);
    const { transitional: r, paramsSerializer: s, headers: i } = n;
    r !== void 0 && oe.assertOptions(r, {
      silentJSONParsing: F.transitional(F.boolean),
      forcedJSONParsing: F.transitional(F.boolean),
      clarifyTimeoutError: F.transitional(F.boolean)
    }, !1), s != null && (a.isFunction(s) ? n.paramsSerializer = {
      serialize: s
    } : oe.assertOptions(s, {
      encode: F.function,
      serialize: F.function
    }, !0)), n.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? n.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : n.allowAbsoluteUrls = !0), oe.assertOptions(n, {
      baseUrl: F.spelling("baseURL"),
      withXsrfToken: F.spelling("withXSRFToken")
    }, !0), n.method = (n.method || this.defaults.method || "get").toLowerCase();
    let o = i && a.merge(
      i.common,
      i[n.method]
    );
    i && a.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (f) => {
        delete i[f];
      }
    ), n.headers = A.concat(o, i);
    const c = [];
    let d = !0;
    this.interceptors.request.forEach(function(m) {
      typeof m.runWhen == "function" && m.runWhen(n) === !1 || (d = d && m.synchronous, c.unshift(m.fulfilled, m.rejected));
    });
    const l = [];
    this.interceptors.response.forEach(function(m) {
      l.push(m.fulfilled, m.rejected);
    });
    let u, p = 0, b;
    if (!d) {
      const f = [Qe.bind(this), void 0];
      for (f.unshift(...c), f.push(...l), b = f.length, u = Promise.resolve(n); p < b; )
        u = u.then(f[p++], f[p++]);
      return u;
    }
    b = c.length;
    let w = n;
    for (; p < b; ) {
      const f = c[p++], m = c[p++];
      try {
        w = f(w);
      } catch (h) {
        m.call(this, h);
        break;
      }
    }
    try {
      u = Qe.call(this, w);
    } catch (f) {
      return Promise.reject(f);
    }
    for (p = 0, b = l.length; p < b; )
      u = u.then(l[p++], l[p++]);
    return u;
  }
  getUri(t) {
    t = H(this.defaults, t);
    const n = yt(t.baseURL, t.url, t.allowAbsoluteUrls);
    return ft(n, t.params, t.paramsSerializer);
  }
};
a.forEach(["delete", "get", "head", "options"], function(t) {
  M.prototype[t] = function(n, r) {
    return this.request(H(r || {}, {
      method: t,
      url: n,
      data: (r || {}).data
    }));
  };
});
a.forEach(["post", "put", "patch"], function(t) {
  function n(r) {
    return function(i, o, c) {
      return this.request(H(c || {}, {
        method: t,
        headers: r ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: i,
        data: o
      }));
    };
  }
  M.prototype[t] = n(), M.prototype[t + "Form"] = n(!0);
});
let rr = class St {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let n;
    this.promise = new Promise(function(i) {
      n = i;
    });
    const r = this;
    this.promise.then((s) => {
      if (!r._listeners) return;
      let i = r._listeners.length;
      for (; i-- > 0; )
        r._listeners[i](s);
      r._listeners = null;
    }), this.promise.then = (s) => {
      let i;
      const o = new Promise((c) => {
        r.subscribe(c), i = c;
      }).then(s);
      return o.cancel = function() {
        r.unsubscribe(i);
      }, o;
    }, t(function(i, o, c) {
      r.reason || (r.reason = new V(i, o, c), n(r.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const n = this._listeners.indexOf(t);
    n !== -1 && this._listeners.splice(n, 1);
  }
  toAbortSignal() {
    const t = new AbortController(), n = (r) => {
      t.abort(r);
    };
    return this.subscribe(n), t.signal.unsubscribe = () => this.unsubscribe(n), t.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new St(function(s) {
        t = s;
      }),
      cancel: t
    };
  }
};
function sr(e) {
  return function(n) {
    return e.apply(null, n);
  };
}
function or(e) {
  return a.isObject(e) && e.isAxiosError === !0;
}
const Re = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511,
  WebServerIsDown: 521,
  ConnectionTimedOut: 522,
  OriginIsUnreachable: 523,
  TimeoutOccurred: 524,
  SslHandshakeFailed: 525,
  InvalidSslCertificate: 526
};
Object.entries(Re).forEach(([e, t]) => {
  Re[t] = e;
});
function Rt(e) {
  const t = new M(e), n = Ye(M.prototype.request, t);
  return a.extend(n, M.prototype, t, { allOwnKeys: !0 }), a.extend(n, t, null, { allOwnKeys: !0 }), n.create = function(s) {
    return Rt(H(e, s));
  }, n;
}
const g = Rt(Z);
g.Axios = M;
g.CanceledError = V;
g.CancelToken = rr;
g.isCancel = pt;
g.VERSION = Et;
g.toFormData = ue;
g.AxiosError = y;
g.Cancel = g.CanceledError;
g.all = function(t) {
  return Promise.all(t);
};
g.spread = sr;
g.isAxiosError = or;
g.mergeConfig = H;
g.AxiosHeaders = A;
g.formToJSON = (e) => ht(a.isHTMLForm(e) ? new FormData(e) : e);
g.getAdapter = gt.getAdapter;
g.HttpStatusCode = Re;
g.default = g;
const {
  Axios: lr,
  AxiosError: ur,
  CanceledError: fr,
  isCancel: dr,
  CancelToken: hr,
  VERSION: pr,
  all: mr,
  Cancel: yr,
  isAxiosError: br,
  spread: wr,
  toFormData: gr,
  AxiosHeaders: Er,
  HttpStatusCode: Sr,
  formToJSON: Rr,
  getAdapter: Or,
  mergeConfig: Tr
} = g;
class Ar {
  constructor(t) {
    this.axiosInstance = void 0, this.isStarted = !1, this.userId = void 0, this.sendUserIdInterval = void 0, this.onLog = t == null ? void 0 : t.onLog, this.onError = t == null ? void 0 : t.onError;
  }
  getIsStarted() {
    return this.isStarted;
  }
  start(t, n) {
    var r;
    (r = this.onLog) == null || r.call(this, `DIS Manager start called with port=${t} userId=${n}`), this.isStarted = !0, this.userId = n, this.axiosInstance = g.create({
      baseURL: `http://localhost:${t}/api`,
      headers: {
        "Content-Type": "application/json"
      }
    }), this.sendUserId(), this.sendUserIdInterval = setInterval(() => {
      this.isStarted && this.userId && this.sendUserId();
    }, 12e4);
  }
  sendUserId() {
    var t, n;
    if (this.isStarted)
      return (t = this.onLog) == null || t.call(this, "DIS Manager sendUserId called"), (n = this.axiosInstance) == null ? void 0 : n.post("desktopintegration/context/login", JSON.stringify(this.userId)).then((r) => {
        var s;
        return (s = this.onLog) == null || s.call(
          this,
          `DIS Manager POST ${this.userId} to desktopintegration/context/login`
        ), r;
      }).catch((r) => {
        var s;
        (s = this.onError) == null || s.call(this, r);
      });
  }
  getMetadata() {
    var t, n;
    if (this.isStarted)
      return (t = this.onLog) == null || t.call(this, "DIS Manager getMetadata called"), (n = this.axiosInstance) == null ? void 0 : n.get("metadata").then((r) => {
        var s;
        return (s = this.onLog) == null || s.call(this, "DIS Manager GET from metadata"), r;
      }).catch((r) => {
        var s;
        throw (s = this.onError) == null || s.call(this, r), r;
      });
  }
  logout() {
    var t, n;
    if (this.isStarted)
      return (t = this.onLog) == null || t.call(this, "DIS Manager logout called"), (n = this.axiosInstance) == null ? void 0 : n.post("desktopintegration/context/logout").then((r) => {
        var s;
        return (s = this.onLog) == null || s.call(this, "DIS Manager POST to desktopintegration/context/logout"), r;
      }).catch((r) => {
        var s;
        throw (s = this.onError) == null || s.call(this, r), r;
      }).finally(() => {
        this.sendUserIdInterval && (clearInterval(this.sendUserIdInterval), this.sendUserIdInterval = void 0), this.userId = void 0, this.isStarted = !1;
      });
  }
}
export {
  Ar as DisManager
};
